<template>
  <form
    autocomplete="off"
    class="admin-wheelchair-accessories-form"
    @reset.prevent="handleCancel"
    @submit.prevent="handleSave"
  >
    <fieldset>
      <label>
        <span class="required">Name</span>

        <input
          autofocus
          :disabled="disabled"
          id="admin-wheelchair-accessory-name"
          required
          type="text"
          v-model.trim="name"
        />
      </label>

      <label>
        <span>Name Fr</span>

        <input
          :disabled="disabled"
          id="admin-wheelchair-accessory-name-fr"
          type="text"
          v-model.trim="name_fr"
        />
      </label>

      <EquipmentSpecificationOptionsTable
        class="admin-wheelchair-accessory-options"
        :disabled="disabled || !canSave"
        :options.sync="options"
      />
    </fieldset>

    <footer>
      <button
        :disabled="!isDeleteEnabled"
        id="admin-wheelchair-accessory-delete"
        type="button"
        @click="handleDelete"
        v-if="canDelete && accessory.id"
      >Delete</button>

      <button
        :disabled="!isSaveEnabled"
        id="admin-wheelchair-accessory-save"
        type="submit"
        v-if="canSave"
      >Save</button>

      <button
        :disabled="!isCancelEnabled"
        id="admin-wheelchair-accessory-cancel"
        type="reset"
        v-if="canCancel"
      >Cancel</button>
    </footer>
  </form>
</template>

<script>
import EquipmentSpecificationOptionsTable from "./EquipmentSpecificationOptionsTable";

import {
  deleteWheelchairAccessory,
  saveWheelchairAccessory
} from "../../api/EquipmentAPI";

export default {
  data() {
    return {
      name: undefined,
      name_fr: undefined,
      option: {},
      options: []
    };
  },

  props: {
    accessory: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    canCancel() {
      return true;
    },
    canDelete() {
      return this.can("DELETE_EQUIPMENT_PARTS");
    },
    canSave() {
      return this.can({ permissions: ["CREATE_EQUIPMENT_PARTS", "UPDATE_EQUIPMENT_PARTS"], matchAny: true });
    },
    isCancelEnabled() {
      return !this.disabled;
    },
    isDeleteEnabled() {
      return !this.disabled && this.accessory?.id && !this.accessory?.protected;
    },
    isSaveEnabled() {
      return (
        !this.disabled &&
        (this.accessory?.id
          ? this.can("UPDATE_EQUIPMENT_PARTS")
          : this.can("CREATE_EQUIPMENT_PARTS"))
      );
    }
  },

  methods: {
    handleCancel() {
      this.$emit("cancel");
    },
    async handleDelete() {
      if (
        !confirm("Are you sure you want to delete this equipment accessory?")
      ) {
        return;
      }

      await deleteWheelchairAccessory(this.accessory);
      this.$emit("delete", this.accessory);
    },
    async handleSave() {
      try {
        this.$emit(
          "save",
          await saveWheelchairAccessory({
            ...this.accessory,
            name: this.name,
            name_fr: this.name_fr,
            options: this.options.map((o, i) => ({ ...o, rank: i + 1 }))
          })
        );
      } catch (e) {
        this.showErrors(e, "An equipment accessory");
      }
    },
    isDirty() {
      if (this.disabled) {
        return false;
      }

      return (
        this.name !== this.accessory?.name ||
        this.name_fr !== this.accessory?.name_fr ||
        JSON.stringify(this.options) !==
          JSON.stringify(this.accessory?.options ?? [])
      );
    }
  },

  watch: {
    accessory: {
      immediate: true,
      handler(to, from) {
        if (to !== from) {
          this.name = to?.name;
          this.name_fr = to?.name_fr;
          this.options = to?.options?.slice?.() ?? [];
          this.option = {};
        }

        !this.disabled && this.autofocus();
      }
    },
    disabled(to, from) {
      !to && from && this.autofocus();
    }
  },

  components: {
    EquipmentSpecificationOptionsTable
  }
};
</script>

<style>
.admin-wheelchair-accessories-form {
  display: grid;
  grid-column-gap: 1em;
  grid-row-gap: 0.5em;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.admin-wheelchair-accessories-form .admin-wheelchair-accessory-options {
  margin-top: 1.15em;
}

.admin-wheelchair-accessories-form > footer {
  grid-column: span 2;
  margin: 0;
  padding: 0.5em 0 0 0;
}
</style>